// extracted by mini-css-extract-plugin
module.exports = {"result":"DocumentResults_result__7XX7x","result-item":"DocumentResults_result-item__Ctjx_"};